module.exports = __webpack_public_path__ + "media/images/application2/AppNav__panel__actions__a--point-5cd12cbb72154308fbdff0f8a0d4d4c9.svg";